import { Injectable } from '@angular/core';
import { IMenuDetails } from '../menu-details-tarifications.component';

@Injectable()
export class MenuDetailsTarificationsService {
    public changeTab (menuDetailsItemsTarifications: IMenuDetails[], tabCode: string): IMenuDetails[] {
        return menuDetailsItemsTarifications.map((item: IMenuDetails): IMenuDetails => {
            item.selected = item.code === tabCode;
            return item;
        });
    }
}
